var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "72px",
    viewBox: "0 0 67 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5EEF60A1-86F1-4794-AAD4-AF80159DACA9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9112069,0 L4.9112069,5.4 L0,5.4 L0,0 L4.9112069,0 Z M26.1931034,0 L26.1931034,5.4 L21.2818966,5.4 L21.2818966,0 L26.1931034,0 Z M15.5521552,0 L15.5521552,5.4 L10.6409483,5.4 L10.6409483,0 L15.5521552,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9112069,46.8 L40.9267241,46.8 L40.9267241,16.2 L4.9112069,16.2 L4.9112069,46.8 Z M39.2962034,5.4 L36.0155172,5.4 L36.0155172,4.156675e-14 L31.1043103,4.156675e-14 L31.1043103,5.4 L14.7336207,5.4 L14.7336207,4.156675e-14 L9.82241379,4.156675e-14 L9.82241379,5.4 L6.54336466,5.4 C2.92871638,5.4 0,8.6202 0,12.5928 L0,45.1854 C0,49.158 2.92871638,52.3782 6.54336466,52.3782 L39.2962034,52.3782 C42.9092147,52.3782 45.837931,49.158 45.837931,45.1854 L45.837931,12.5928 C45.837931,8.6202 42.9092147,5.4 39.2962034,5.4 L39.2962034,5.4 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-477.000000, -710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Copy-2",
    transform: "translate(336.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Calendar/40dp",
    transform: "translate(111.577586, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(19.644828, 30.600000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.644828, -30.600000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 104.772414,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(9.822414, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.822414, -9.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 104.772414,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.32bcdb4a7a6bc4874c120a1962d707e9.svg";
export { ForwardRef as ReactComponent };